import { render, staticRenderFns } from "./logpagelist.vue?vue&type=template&id=9dd6d44a&scoped=true"
import script from "./logpagelist.vue?vue&type=script&lang=js"
export * from "./logpagelist.vue?vue&type=script&lang=js"
import style0 from "./logpagelist.vue?vue&type=style&index=0&id=9dd6d44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd6d44a",
  null
  
)

export default component.exports